// extracted by mini-css-extract-plugin
export default {"root":"mw21TKQX","backButton":"s2KTfv2v","backIcon":"E3bzJgi9","title":"vrSD7J71","titleText":"vpRF8G7U","menuButton":"v4avQQ0R"};